module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1201-retro-min.10820eb1.jpg";